@use 'src/globals/main';

pn-page-nav-dropdown-item {
  &:first-of-type li > a,
  &:first-of-type li > button {
    border-radius: 0.5em 0.5em 0 0;
  }

  &:last-of-type li > a,
  &:last-of-type li > button {
    border-radius: 0 0 0.5em 0.5em;
  }

  &:last-of-type li > hr {
    display: none;
  }
}

pn-page-nav-dropdown-item li {
  font-size: inherit;

  > * {
    color: main.$white;
    font-size: inherit;
    border: none;
    padding: 1em;
    margin: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    transition: background 0.15s;
    outline: none;
    width: 100%;
    font-weight: 500;

    > pn-icon {
      margin-left: 1em;
    }

    &.pn-page-nav-dropdown-item-active {
      background: main.$blue700;

      &:hover,
      &:focus {
        background: main.$blue700;
      }
    }

    &:hover,
    &:focus {
      background: main.$blue900;
    }

    &:focus {
      box-shadow:
        inset 0 0 0 0.1em main.$blue700,
        inset 0 0 0 0.2em main.$gray200;
    }
  }

  > a {
    text-decoration: none;
  }

  > button {
    background: none;
  }

  > hr {
    bottom: 0;
    padding: 0;
    margin: 0 auto;
    border-top: 0.0625em solid main.$gray200;
    opacity: 0.6;
    width: 85%;
  }
}
